import Map from "@/assets/gifs/task/art-board.gif";
import AE from "@/assets/svg/task/ae-1.svg";
import HK from "@/assets/svg/task/hk-1.svg";
import PH from "@/assets/svg/task/ph-1.svg";
import US from "@/assets/svg/task/us-1.svg";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { useEffect, useState } from "react";

export default function ArtBoard() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [api, setApi] = useState(null);

  const locations = [
    { img: HK, name: "Hongkong, HK" },
    { img: AE, name: "Dubai, UAE" },
    { img: US, name: "Kansas City, USA" },
    { img: PH, name: "Metro Manila, Philippines" },
  ];

  useEffect(() => {
    if (!api) return;

    // Set initial index
    setActiveIndex(api.selectedScrollSnap());

    // Update index on slide change
    api.on("select", () => {
      setActiveIndex(api.selectedScrollSnap());
    });
  }, [api]);

  return (
    <div className="lg:py-12 space-y-12 4xl:max-w-[100rem] 4xl:mx-auto">
      <div className="space-y-4 text-center px-12">
        <h1 className="text-4xl md:text-5xl text-primaryLight">
          We have a global and diverse team
        </h1>
        <p className="text-[#EDE9FE] max-w-4xl mx-auto text-sm md:text-lg">
          EnfiniTask is built for creators and businesses everywhere. Whether
          you’re collaborating locally or scaling globally, our team connects
          seamlessly across borders to deliver consistent, high-quality
          results—no matter where you are.
        </p>
      </div>
      <img src={Map} className="hidden lg:block" alt="Art Board" />

      <div className="block md:hidden relative h-[400px]">
        <Carousel className="w-full h-full" setApi={setApi}>
          <CarouselContent className="h-full">
            {locations.map((loc, i) => (
              <CarouselItem
                key={i}
                className="h-full flex items-center justify-center"
              >
                <img src={loc.img} alt={loc.name} className="w-full" />
              </CarouselItem>
            ))}
          </CarouselContent>

          <div className="flex items-center justify-center gap-6 text-primaryLight w-full relative">
            <CarouselPrevious className="absolute top-1/2 -translate-y-1/2 left-8 bg-transparent border-0" />
            <p className="text-lg font-medium">
              {locations[activeIndex]?.name}
            </p>
            <CarouselNext className="absolute top-1/2 -translate-y-1/2 right-8 bg-transparent border-0" />
          </div>
        </Carousel>
      </div>
    </div>
  );
}
